export default "__VITE_ASSET__DZ17obYq__"